<template>
  <div class="setup-price">
    <div class="update-notification" v-if="contentOwnership.status === 'active'">
      <h1 class="f9">{{ $t('Price Updates') }}</h1>
      <p
        class="f5"
      >{{ $t('Price updates (including regional prices) take effect for locations on the 1st day of each month to give locations a fair amount of time to review the changes:') }}</p>
      <ul class="f5">
        <li>
          {{ $t('Any changes you make within the 1st half of the month will be effective on the 1st of the next month.') }}
          <i>{{ $t('If you update your prices between January 1st and January 14th, your prices will be updated for locations on February 1st.') }}</i>
        </li>
        <li>
          {{ $t('Any changes you make within the 2nd half of the month will take effect on the 1st of the following month.') }}
          <i>{{ $t('If you update your prices between January 15th and January 31st, your prices will be updated for locations on March 1st.') }}</i>
        </li>
      </ul>
    </div>
    <BasePrice
      :contentOwnership="contentOwnership"
      v-on="$listeners"
      :yearlyPricingLock="yearlyPricingLock"
    />
    <RegionalPricing
      v-if="countries"
      :countries="countries"
      :contentOwnership="contentOwnership"
      v-on="$listeners"
    />
    <Distribute
      :contentOwnership="contentOwnership"
      v-on="$listeners"
      :distributeEntertainmentLock="distributeEntertainmentLock"
      :distributeEducationLock="distributeEducationLock"
    />
  </div>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import ContentBlock from '@/core/shared/components/ContentBlock';
import BasePrice from '../content-fields/BasePrice';
import RegionalPricing from '../content-fields/RegionalPricing';
import Distribute from '../content-fields/Distribute';
import moment from 'moment-timezone';

@Component({
  components: {
    ContentBlock,
    BasePrice,
    RegionalPricing,
    Distribute,
  },
  props: {
    contentOwnership: { type: Object, required: true },
    countries: { type: Array, required: true },
    distributeEntertainmentLock: { type: Boolean },
    distributeEducationLock: { type: Boolean },
    yearlyPricingLock: { type: Boolean },
  },
})
export default class TabPricingRoute extends Vue {
  get upcomingPriceDate () {
    return moment(this.contentOwnership.newPriceChangeDate).format('LL');
  }
}
</script>
